import { call, put } from 'redux-saga/effects';
import { Messages } from '../../../../codegen/Localize';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { DataQualityWarningActions } from '../../../../catalog/contentActions/DataQualityWarningActions';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';
import { SetDataQualityAction } from '../../../actions/spaces/SetDataQualityAction';
import { DataQualityDialogState, getDataQualityActionDialogOptions, defaultInitialState } from '../../../quality/DataQualityDialog';
import { ServiceLocator } from '../../../ServiceLocator';
import { replaceDatasourceIdWithConnectionIdForMixedContent } from '../SpacesSagaHelpers';
import { fetchContent, reloadSpaceIfUpdatingCurrentSpace } from './RefreshContentSagas';
import { userEditableDataQualityTypes, stringToDataQualityType } from '../../../quality/DataQualityType';
import { openReactActionDialog } from '../../../../commonInfra/dialogs/ReactActionDialog';

export function* handleSetDataQuality(action: SetDataQualityAction) {
  try {
    let mutatableContentCopy: IContentInfo[] = [];
    mutatableContentCopy = yield call(replaceDatasourceIdWithConnectionIdForMixedContent, [action.item]);
    const first = mutatableContentCopy[0] ?? undefined;
    const item: IContentInfo = yield fetchContent(first);

    yield call(openDataQualityDialog, {type: action.type, item});

    const maybeReloaded = yield call(reloadSpaceIfUpdatingCurrentSpace, [action.item]);
    if (!maybeReloaded) {
      yield put(requestSpaceContents());
    }

  } catch(e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function openDataQualityDialog(action: SetDataQualityAction): PromiseLike<unknown> {

  const indicator = action.item.dataQualityIndicators.find(
    dqi => userEditableDataQualityTypes.includes(stringToDataQualityType(dqi.type))
  );
  const isUpdate = !!indicator && !!indicator.id;

  let contentItemId = action.item.id;
  if (action.item.contentType === 'table' || action.item.contentType === 'database') {
    contentItemId = action.item.vizportalId;
  }

  const addDataQualityWarning = (state: DataQualityDialogState) => {
    return DataQualityWarningActions.addDataQualityWarning({
      contentName: action.item.name,
      contentId: contentItemId,
      contentType: action.item.contentType,
      ...state
    });
  };

  const updateDataQualityWarning = (state: DataQualityDialogState) => {
    if (state.isActive || state.message.length > 0) {
      return DataQualityWarningActions.updateDataQualityWarning({
        contentName: action.item.name,
        id: indicator.id,
        ...state
      });
    } else {
      return DataQualityWarningActions.deleteDataQualityWarning({
        contentName: action.item.name,
        id: indicator.id
      });
    }
  };

  const setDataQualityWarning = isUpdate ? updateDataQualityWarning : addDataQualityWarning;

  const modalInstance = openReactActionDialog(getDataQualityActionDialogOptions({
    initialBodyProps: { contentName: action.item.name },
    initialFormData: isUpdate ? { ...indicator } : defaultInitialState,
    doAction: setDataQualityWarning
  }));
  return modalInstance.result;
}
